<template>
  <!-- <Card>
    <div class="MapBox">
      <div id="allmap"></div>
    </div>
  </Card> -->
  <div class="MapBox" v-if="userEqui == 'pc'">
    <div id="allmap"></div>
  </div>
  <div
    class="MapBox"
    :style="{ width: this.equiWidth, height: '300px' }"
    v-else
  >
    <div id="allmap"></div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../../router";
import { mapGetters } from "vuex";
import Card from "@/components/Card/index.vue";
import { BMPGL } from "@/util/bmpgl.js";
import { selectCountAreaOfNum } from "@/api/projectManage.js";
import orderInfoWindow from "./orderInfoWindow.vue";
import { offsetLocation } from "../../../js/utils/util";
import { getBiddingXmxxByPg } from "@/api/projectManage";
export default {
  components: {
    // Card,
  },
  props: ["cqlxbh"],
  data() {
    return {
      ak: window.global.bmKey, //
      lon: window.global.view.center[0],
      lat: window.global.view.center[1],
      zoom: window.global.view.zoom, //地图的缩放级别
      icon: require("../../../assets/resourceHall-Icon/耕地.png"), //标记点使用的图标
      YTZYList: [],
      doneList: [],
      map: null,
      BMapGL: null,
      gencoder: null,
      getDataList: [], //存储项目列表数据的数组
      getDataList2: [], //存储项目列表数据的数组
      params: {
        pnum: 1,
        psize: 10,
      },
      currentInfoWindow: null,
      markers: [],
      comapnyMarkerClusterer: null,
      baseUrl: window.globalUrl.HOME_API,
      initState: false,
      userEqui: sessionStorage.getItem("equiType"),
      equiWidth: sessionStorage.getItem("equiWidth"), //设备宽度 参数为用户当前设备的实际宽度（单位：px）
      zoomRules: [
        { min: 0, max: 9 }, //市聚合
        { min: 9, max: 13 }, //区县聚合
        { min: 13, max: 14 }, //乡镇聚合
        { min: 14, max: 17 }, //街道具体坐标
      ], //缩放级别划分字典
      zoomLevel: "",
      areaCode: "", //当前中心点所在地行政编码（标准9位）
      infoWindows: [], //气泡管理
      zzflag:true,//是否调用层级4的数据
      pageSize:500,//每页请求的数据量
      timeoutIds:[],//定时器存储
    };
  },
  computed: {
    ...mapGetters(["topSelectAreacode", "topSelectAreaname", "identityObj"]),
  },
  //监听地区的变化设为中心点
  watch: {
    topSelectAreaname: function () {
      this.setMapCenter(this.topSelectAreaname); //设置地图中心点
      this.clearMarkers();
      // this.selectCountAreaOfNum(); //获取地区宗数数据列表
      // this.getCompanyList();
      // this.getAgriculturalList();
      // this.centerPointChange();//暂时不适用
      this.getOrderList()
    },
    cqlxbh: function (e) {
      this.setMapCenter(this.topSelectAreaname); //设置地图中心点
      this.clearMarkers();
      // this.selectCountAreaOfNum(); //获取地区宗数数据列表
      // this.centerPointChange();//暂时不适用
      this.getOrderList()
    },
  },

  mounted() {
    this.initMap();
    // this.selectCountAreaOfNum(); //获取资源资产宗数数据
    this.setMapCenter(this.topSelectAreaname); //根据地区名称设置地图中心点
    this.$bus.$on('zyzcListChange', ({data}) => {
      this.zyzcListChange1(data);
    });
  },

  methods: {
    //点击资源资产列表
    zyzcListChange1(data){
      console.log('资源资产点击单行',data)
      if (!this.BMapGL || !this.map) return;
      console.log('1212',this.markers)
        const marker = this.markers.find(item => {
          if (item.orderData) {
            let orderData = item.orderData;
            if (orderData.xmbsm === data.xmbsm) {
              return  item;
            }
          }
        })
        if (!marker) return;
        const point = marker.getPosition();
        this.map.centerAndZoom(point, 16);
        if (this.currentInfoWindow) {
        this.map.closeInfoWindow(this.currentInfoWindow);
      }
        this.showOrderInfo(marker)
    },
    //获取地图信息数据（临时低配版）
    async getOrderList(){
          try {
          const firstPage = await getBiddingXmxxByPg({
            current: 1,
            size:this.pageSize,
            xzqbh: this.topSelectAreacode,
            cqlx: this.cqlxbh,
          });
          this.clearAllTimeouts();
          console.log('看看firstPage',firstPage)
          if (firstPage.data.records.length) {
            this.addOrderMarkers(firstPage.data.records);
          }

          // const sumCount = firstPage.data.total;
          // const totalPage = Math.ceil(sumCount / this.pageSize);
          // console.log('查看总页数',totalPage)
          // // 使用setTimeout异步加载剩余页数据
          // for (let i = 2; i <= totalPage; i++) {
          //   const timeoutId = setTimeout(async () => {
          //     const pageData = await getBiddingXmxxByPg({
          //       current: i,
          //   size:this.pageSize,
          //   xzqbh: this.topSelectAreacode,
          //   cqlx: this.cqlxbh,
          //     })
          //     if (pageData.data.records.length) {
          //       this.addOrderMarkers(pageData.data.records);
          //     }
          //     this.timeoutIds = this.timeoutIds.filter(id => id !== timeoutId);
          //   }, (i-1) * 1500)
          //   this.timeoutIds.push(timeoutId);
          // }
      } catch (error) {
        console.error('农机服务商数据获取失败:', error);
      }
    },
    //清除所有定时器
    clearAllTimeouts() {
    // 清除所有定时器
    this.timeoutIds.forEach(id => clearTimeout(id));
    this.timeoutIds = [];
    console.log('已取消所有数据加载请求');
  },
    initMap() {
      if (this.initState == true) {
        return;
      }
      this.initState = true;
      // 传入密钥获取地图回调。
      BMPGL(this.ak)
        .then((BMapGL) => {
          // 创建地图实例
          let map = new BMapGL.Map("allmap");
          // 创建点坐标 axios => res 获取的初始化定位坐标
          let point = new BMapGL.Point(this.lon, this.lat);
          let geocoder = new BMapGL.Geocoder();
          map.setMapType(BMAP_SATELLITE_MAP);
          var styleJson = [
            {
              featureType: "transit", // 例如，隐藏公交站
              elementType: "labels",
              stylers: {
                visibility: "off",
              },
            },
            // 隐藏商业区域标签
            {
              featureType: "poi",
              elementType: "labels",
              stylers: { visibility: "off" },
            },
            // 隐藏水系标签
            {
              featureType: "water",
              elementType: "labels",
              stylers: { visibility: "off" },
            },
            // 隐藏道路标签（路标）
            {
              featureType: "road.label",
              elementType: "labels",
              stylers: {
                visibility: "off",
              },
            },
            // 隐藏植被区域（树林）
            {
              featureType: "vegetation",
              elementType: "all",
              stylers: {
                visibility: "off",
              },
            },
          ];
          map.setMapStyleV2({ styleJson: styleJson }); // 应用自定义样式
          // 初始化地图，设置中心点坐标和地图级别
          map.centerAndZoom(point, this.zoom);
          //开启鼠标滚轮缩放
          map.enableScrollWheelZoom(true);
          // 添加缩放控件
          var zoomCtrl = new BMapGL.ZoomControl();
          map.addControl(zoomCtrl);
          map.setMaxZoom(18);
          map.addEventListener("zoomend", this.handleZoomChange); //地图缩放级别监听方法
          map.addEventListener("moveend", this.centerPointChange); //地图缩放级别监听方法
          this.zoomLevel = this.getZoomLevel();
          // 保存数据
          this.BMapGL = BMapGL;
          this.map = map;
          this.gencoder = geocoder;
          this.centerPointChange();
        })
        .catch((err) => {});
    },
    //计算当前所在缩放等级
    getZoomLevel() {
      for (let i in this.zoomRules) {
        if (
          this.zoom <= this.zoomRules[i].max &&
          this.zoom > this.zoomRules[i].min
        ) {
          return i;
        }
      }
    },
    //监听中心点变化
    centerPointChange() {
      return
      const centerPoint = this.map.getCenter();
      this.lon = centerPoint.lng;
      this.lat = centerPoint.lat;
      this.lon = parseFloat(centerPoint.lng);
      this.lat = parseFloat(centerPoint.lat);
      const point = new this.BMapGL.Point(this.lon, this.lat);
      const geocoder = new this.BMapGL.Geocoder();
      let areaCode = "";
      geocoder.getLocation(point, (result) => {
        if (result) {
          const addrComp = result.content.address_detail;
          areaCode = addrComp.town_code; //当前最新的中心点行政区号
          console.log("旧行政编码和新行政编码", this.areaCode, areaCode);
          if (this.zoomLevel == "0") {
            this.zzflag=true
            let areaCodeOld = this.areaCode.substring(0, 2);
            let areaCodeNew = areaCode.substring(0, 2);
            if (areaCodeOld != areaCodeNew) {
              this.clearMarkers();
              this.selectCountAreaOfNum(areaCodeNew);
            }
          } else if (this.zoomLevel == "1") {
            this.zzflag=true
            let areaCodeOld = this.areaCode.substring(0, 4);
            let areaCodeNew = areaCode.substring(0, 4);
            if (areaCodeOld != areaCodeNew) {
              this.clearMarkers();

              this.selectCountAreaOfNum(areaCodeNew);
            }
          } else if (this.zoomLevel == "2") {
            this.zzflag=true
            let areaCodeOld = this.areaCode.substring(0, 6);
            let areaCodeNew = areaCode.substring(0, 6);
            if (areaCodeOld != areaCodeNew) {
              this.clearMarkers();
              this.selectCountAreaOfNum(areaCodeNew);
            }
          } else if (this.zoomLevel == "3") {
            // if(this.zzflag==false){
            //   return
            // }
            // this.zzflag=false
            let areaCodeOld = this.areaCode.substring(0, 6);
            let areaCodeNew = areaCode.substring(0, 6);
            if (areaCodeOld != areaCodeNew) {
              this.clearMarkers();
              this.selectCountAreaOfNum(areaCodeNew);
            }
          }
          this.areaCode = areaCode;
          console.log("更新后的areaCode", this.areaCode);
        }
      });
    },
    //监听缩放级别变化
    handleZoomChange() {
      return
      const zoom = this.map.getZoom();
      this.zoom = zoom;
      console.log("当前缩放级别", this.zoom);
      if (this.getZoomLevel() != this.zoomLevel) {
        this.zoomLevel = this.getZoomLevel();
        this.clearMarkers();
        if (this.getZoomLevel() == "0") {
          let areaCodeNew = this.areaCode.substring(0, 2);
          this.selectCountAreaOfNum(areaCodeNew);
        } else if (this.getZoomLevel() == "1") {
          let areaCodeNew = this.areaCode.substring(0, 4);
          this.selectCountAreaOfNum(areaCodeNew);
        } else if (this.getZoomLevel() == "2") {
          let areaCodeNew = this.areaCode.substring(0, 6);
          this.selectCountAreaOfNum(areaCodeNew);
        } else if (this.getZoomLevel() == "3") {
          let areaCodeNew = this.areaCode.substring(0, 9);
          this.selectCountAreaOfNum(areaCodeNew);
        }
      }
    },
    // 根据地区名称设置地图中心点
    async setMapCenter(areaName) {
      if (!this.BMapGL) return;
      const geocoder = new this.BMapGL.Geocoder();
      geocoder.getPoint(
        areaName,
        (point) => {
          if (point) {
            this.map.centerAndZoom(point, this.zoom);
            // 如果需要保存最新中心点
            this.lon = point.lng;
            this.lat = point.lat;
          }
        },
        "全国"
      ); // 可以指定省市区提升准确性
    },
    // 获取地图功能地区宗数列表
    async selectCountAreaOfNum(areaCode) {
      console.log(
        "在selectCountAreaOfNum内查看当前areaCode和zoom和zoomLevel",
        this.areaCode,
        this.zoomLevel,
        this.zoom,
        areaCode
      );
      if (this.zoomLevel != "3") {
        try {
          let firstPage = await selectCountAreaOfNum({
            pnum: 1,
            psize: 500,
            areaCode: areaCode,
            cqlxbh: this.cqlxbh || "02",
          });
          //过滤掉宗数为0的数据
          if (firstPage.data.length) {
            // firstPage.data=firstPage.data.filters(item=>item.totalPeople!=0)
            firstPage.data.forEach((item, index) => {
              if (item.totalPeople == 0) {
                delete firstPage.data[index];
              }
            });
            console.log("过滤后的firstPage", firstPage.data);
          }
          this.addOrderMarkers1(firstPage.data);
        } catch (error) {
          console.log(error);
        }
      } else {
        console.log("zoomLevel为3,执行逻辑");
        try {
          const res = await getBiddingXmxxByPg({
            current: 1,
            size: 500,
            xzqbh: areaCode,
            cqlx: this.cqlxbh,
          });
          let { status, data, message } = res;
          let firstPage = { data: [] };
          for (let i in data.records) {
            let obj = {
              areaCode: data.records[i].xzqbh,
              areaName: data.records[i].xmmc,
              centerPoint: data.records[i].centerPoint,
              totalArea: data.records[i].flowAreaMu,
              price: data.records[i].gpjg,
              xmbh: data.records[i].xmbh,
            };
            firstPage.data.push(obj);
          }
          console.log("firstPage.data", firstPage.data);
          if (firstPage.data) {
            if (this.cqlxbh == "01") {
              //集体建设用地
              this.icon = require("../../../assets/resourceHall-Icon/建筑用地.png");
            } else if (this.cqlxbh == "02") {
              //耕地图标
              this.icon = require("../../../assets/resourceHall-Icon/耕地.png");
            } else if (this.cqlxbh == "03") {
              //草地
              this.icon = require("../../../assets/resourceHall-Icon/草地.png");
            } else if (this.cqlxbh == "04") {
              //林地
              this.icon = require("../../../assets/resourceHall-Icon/林地.png");
            } else if (this.cqlxbh == "05") {
              //四荒地
              this.icon = require("../../../assets/resourceHall-Icon/四荒地.png");
            } else if (this.cqlxbh == "06") {
              //宅基地及农房
              this.icon = require("../../../assets/resourceHall-Icon/宅基地.png");
            } else if (this.cqlxbh == "07") {
              //农业生产设施设备
              this.icon = require("../../../assets/resourceHall-Icon/农业生产.png");
            } else if (this.cqlxbh == "08") {
              //农业知识产权
              this.icon = require("../../../assets/resourceHall-Icon/知识产权.png");
            } else if (this.cqlxbh == "09") {
              //园地
              this.icon = require("../../../assets/resourceHall-Icon/园地.png");
            } else if (this.cqlxbh == "10") {
              //水域
              this.icon = require("../../../assets/resourceHall-Icon/水域.png");
            }
            this.addOrderMarkers(firstPage.data);
          }
          this.getSpecificMarkers(areaCode);
        } catch (error) {}
      }
    },
    //具体坐标分页加载
    async getSpecificMarkers(areaCode) {
      console.log('具体坐标入参areaCode',areaCode)
      let areaCodeSix = areaCode.substring(0, 6);
      console.log('截取后的areaCode',areaCodeSix)
      const res = await getBiddingXmxxByPg({
        current: 1,
        size: 500,
        xzqbh: areaCodeSix,
        cqlx:  this.cqlxbh,
      });
      console.log('我看看res1111',res)
      let { status, data, message } = res;
          let firstPage = { data: [] };
          for (let i in data.records) {
            let obj = {
              areaCode: data.records[i].xzqbh,
              areaName: data.records[i].xmmc,
              centerPoint: data.records[i].centerPoint,
              totalArea: data.records[i].flowAreaMu,
              price: data.records[i].gpjg,
              xmbh: data.records[i].xmbh,
            };
            firstPage.data.push(obj);
          }
          console.log("firstPage.data", firstPage.data);
          if (firstPage.data) {
            if (this.cqlxbh == "01") {
              //集体建设用地
              this.icon = require("../../../assets/resourceHall-Icon/建筑用地.png");
            } else if (this.cqlxbh == "02") {
              //耕地图标
              this.icon = require("../../../assets/resourceHall-Icon/耕地.png");
            } else if (this.cqlxbh == "03") {
              //草地
              this.icon = require("../../../assets/resourceHall-Icon/草地.png");
            } else if (this.cqlxbh == "04") {
              //林地
              this.icon = require("../../../assets/resourceHall-Icon/林地.png");
            } else if (this.cqlxbh == "05") {
              //四荒地
              this.icon = require("../../../assets/resourceHall-Icon/四荒地.png");
            } else if (this.cqlxbh == "06") {
              //宅基地及农房
              this.icon = require("../../../assets/resourceHall-Icon/宅基地.png");
            } else if (this.cqlxbh == "07") {
              //农业生产设施设备
              this.icon = require("../../../assets/resourceHall-Icon/农业生产.png");
            } else if (this.cqlxbh == "08") {
              //农业知识产权
              this.icon = require("../../../assets/resourceHall-Icon/知识产权.png");
            } else if (this.cqlxbh == "09") {
              //园地
              this.icon = require("../../../assets/resourceHall-Icon/园地.png");
            } else if (this.cqlxbh == "10") {
              //水域
              this.icon = require("../../../assets/resourceHall-Icon/水域.png");
            }
            this.addOrderMarkers(firstPage.data);
          }
     return
      for (const item of res.data.records) {
        // 🟢 修复1：改用支持异步的循环
        let areaCodeNine=item.xzqbh.substring(0,9)
        if (areaCodeNine !== areaCode) {
          const res1 = await getBiddingXmxxByPg({
            current: 1,
            size: 500,
            xzqbh: areaCodeNine,
            cqlx: this.cqlxbh,
          });
          // 🟢 修复2：取消注释并合并数据
          let { status, data, message } = res1;
          let firstPage = { data: [] };
          for (let i in data.records) {
            let obj = {
              areaCode: data.records[i].xzqbh,
              areaName: data.records[i].xmmc,
              centerPoint: data.records[i].centerPoint,
              totalArea: data.records[i].flowAreaMu,
              price: data.records[i].gpjg,
              xmbh: data.records[i].xmbh,
            };
            firstPage.data.push(obj);
          }
          console.log("firstPage.data", firstPage.data);
          if (firstPage.data) {
            if (this.cqlxbh == "01") {
              //集体建设用地
              this.icon = require("../../../assets/resourceHall-Icon/建筑用地.png");
            } else if (this.cqlxbh == "02") {
              //耕地图标
              this.icon = require("../../../assets/resourceHall-Icon/耕地.png");
            } else if (this.cqlxbh == "03") {
              //草地
              this.icon = require("../../../assets/resourceHall-Icon/草地.png");
            } else if (this.cqlxbh == "04") {
              //林地
              this.icon = require("../../../assets/resourceHall-Icon/林地.png");
            } else if (this.cqlxbh == "05") {
              //四荒地
              this.icon = require("../../../assets/resourceHall-Icon/四荒地.png");
            } else if (this.cqlxbh == "06") {
              //宅基地及农房
              this.icon = require("../../../assets/resourceHall-Icon/宅基地.png");
            } else if (this.cqlxbh == "07") {
              //农业生产设施设备
              this.icon = require("../../../assets/resourceHall-Icon/农业生产.png");
            } else if (this.cqlxbh == "08") {
              //农业知识产权
              this.icon = require("../../../assets/resourceHall-Icon/知识产权.png");
            } else if (this.cqlxbh == "09") {
              //园地
              this.icon = require("../../../assets/resourceHall-Icon/园地.png");
            } else if (this.cqlxbh == "10") {
              //水域
              this.icon = require("../../../assets/resourceHall-Icon/水域.png");
            }
            this.addOrderMarkers(firstPage.data);
          }
        }
      }
      // console.log('处理后的数据', data);
    },

    /**
     *
     * @param dataList 绘制地区宗数地块标点（具体信息）
     */
    addOrderMarkers(dataList) {
      console.log(" addOrderMarkers方法进入", dataList);
      if (!dataList || !this.BMapGL) return;
      const BMapGL = this.BMapGL;
      const markerIcon = new BMapGL.Icon(this.icon, new BMapGL.Size(25, 36));
      markerIcon.setImageSize(new BMapGL.Size(25, 36));
      const coordMap = new Map();
      dataList.forEach((ele, index) => {
        if (ele.centerPoint == null) return;
        const point = ele.centerPoint.split(",");
        //处理偏移量
        const key = `${point[0]},${point[1]}`;
        const count = coordMap.get(key) || 0;
        coordMap.set(key, count + 1);

        // 计算偏移后的点坐标
        let location = offsetLocation(count, point[0], point[1]);
        let pt = new BMapGL.Point(location.lng, location.lat);
        let marker = new BMapGL.Marker(pt, { icon: markerIcon });
        console.log("查看location和pt和marker", location, pt, marker, point);
        // ele.totalArea = ele.totalArea ? ele.totalArea + "亩" : "";
        // ele.totalPeople = ele.totalPeople ? ele.totalPeople + "人" : "";
        ele.zoomLevel = this.zoomLevel;
        marker.orderData = ele;
        console.log("marker", marker);
        marker.addEventListener("click", (e) => {
          this.$router.push({
            name: "projectDetail",
            query: { c: e.target.orderData.xmbh },
          });
        });
        // this.showInfoWindow1(marker,pt, marker.orderData);
        this.markers.push(marker);
        this.map.addOverlay(marker);
      });
      this.showInfoWindow2(dataList); //绘制自定义气泡（城镇以下）
    },
    /**
     *
     * @param dataList 绘制地区宗数地块标点（聚合信息）
     */
    addOrderMarkers1(dataList) {
      this.clearMarkers();
      if (!dataList || !this.BMapGL) return;
      const BMapGL = this.BMapGL;
      const markerIcon = new BMapGL.Icon(this.icon, new BMapGL.Size(25, 36));
      markerIcon.setImageSize(new BMapGL.Size(25, 36));
      dataList.forEach((ele) => {
        if (ele.centerPoint == null) return;
        const point = ele.centerPoint.split(",");
        const point1 = new this.BMapGL.Point(point[0], point[1]);
        const data = { areaName: ele.areaName, totalPeople: ele.totalPeople };
        const icon = this.createCircleIcon(data);
        const marker = new BMapGL.Marker(point1, {
          icon,
          data, // 将数据附加到marker对象上
        });
        this.showInfoWindow(marker, point1, data);
        this.map.addOverlay(marker);
        this.markers.push(marker);
      });
    },
    //设置气泡
    showOrderInfo(marker) {
      console.log("气泡设置");
      if (this.currentInfoWindow) {
        this.map.closeInfoWindow(this.currentInfoWindow);
      }
      const info = marker.orderData;
      const ComponentClass = Vue.extend(orderInfoWindow);
      const instance = new ComponentClass({
        router,
        propsData: {
          info,
        },
      });
      const content = instance.$mount().$el;

      this.currentInfoWindow = new this.BMapGL.InfoWindow(content, {
        width: 10,
        height: 40,
        offset: new this.BMapGL.Size(0, -10),
      });
      this.map.openInfoWindow(this.currentInfoWindow, marker.getPosition());
    },
    // 创建圆形标记
    createCircleIcon(data, bgColor = "#4CAF50", textColor = "white") {
      const size = 72; // 圆形直径
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext("2d");
      // 绘制圆形背景
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2 - 2, 0, Math.PI * 2);
      ctx.fillStyle = bgColor;
      ctx.fill();

      // 添加白色边框
      ctx.lineWidth = 2;
      ctx.strokeStyle = "#fff";
      ctx.stroke();

      // 绘制文字
      ctx.fillStyle = textColor;
      ctx.font = "bold 16px Arial";
      ctx.textAlign = "center";
      // ctx.textBaseline = "middle";
      // const displayText = this.getDisplayText(data);
      // const lines = displayText.split("\n");
      // const fontSize = 12
      // ctx.font = `bold ${fontSize}px Arial`;
      // lines.forEach((line, index) => {
      //   const y = size / 2 + (index - (lines.length - 1) / 2) * fontSize;
      //   ctx.fillText(line, size / 2, y);
      // });
      const areaName = data.areaName || "未知地区";
      const fontSize1 = Math.max(12, size / 5); // 第一行字体大小
      ctx.font = `bold ${fontSize1}px Arial`;
      ctx.textBaseline = "alphabetic"; // 使用alphabetic基线更准确控制位置
      ctx.fillText(
        areaName, // 限制5个字符
        size / 2,
        size / 2 - size / 10 // 精确控制垂直位置
      );

      // 第二行文本：总人数
      const totalPeople =
        data.totalPeople !== undefined ? data.totalPeople : "N/A";
      const fontSize2 = Math.max(10, size / 6); // 第二行字体略小
      ctx.font = `bold ${fontSize2}px Arial`;
      ctx.textBaseline = "hanging"; // 使用hanging基线对齐第二行
      ctx.fillText(
        totalPeople + "宗",
        size / 2,
        size / 2 + size / 10 // 精确控制垂直位置
      );
      return new this.BMapGL.Icon(
        canvas.toDataURL(),
        new this.BMapGL.Size(size, size),
        {
          anchor: new this.BMapGL.Size(size / 2, size / 2), // 中心点对齐
          imageSize: new this.BMapGL.Size(size, size),
        }
      );
    },
    //聚合气泡文本处理
    getDisplayText(data) {
      if (typeof data === "string") return data;
      if (typeof data !== "object" || data === null) return "A";

      // 组合显示多个字段
      const displayParts = [];

      // 按优先级添加字段
      if (data.areaName !== undefined) displayParts.push(`${data.areaName}`);
      if (data.totalPeople !== undefined)
        displayParts.push(`${data.totalPeople}人`);

      // 如果没有有效字段
      if (displayParts.length === 0) return "A";

      // 返回组合后的文本（最多显示两部分）
      return displayParts.slice(0, 2).join(" ");
    },
    //清除标记点
    clearMarkers() {
      console.log("执行清除标记点方法");
      this.markers.forEach((marker) => {
        this.map.removeOverlay(marker);
      });
      if (this.currentInfoWindow) {
        this.map.closeInfoWindow(this.currentInfoWindow);
      }
    },

    //绘制自定义气泡（非聚合）
    showInfoWindow1(dataList) {
      console.log("进入showInfowindow1初始参数", dataList, this.BMapGL);
      if (!dataList || !this.BMapGL) return;
      const BMapGL = this.BMapGL;
      const markerIcon = new BMapGL.Icon(this.icon, new BMapGL.Size(25, 36));
      markerIcon.setImageSize(new BMapGL.Size(25, 36));
      const coordMap = new Map();
      dataList.forEach((ele) => {
        if (ele.centerPoint == null) return;
        const point = ele.centerPoint.split(",");
        const point1 = new this.BMapGL.Point(point[0], point[1]);
        const data = { areaName: ele.areaName, totalPeople: ele.totalPeople };
        const icon = this.createCircleIcon(data);
        const marker = new BMapGL.Marker(point1, {
          icon,
          data, // 将数据附加到marker对象上
        });
        this.showInfoWindow3(marker, point1, data);
        this.map.addOverlay(marker);
        this.markers.push(marker);
      });
    },
    //绘制自定义气泡（城镇以下非聚合）
    showInfoWindow2(dataList) {
      console.log("进入showInfowindow1初始参数", dataList, this.BMapGL);
      if (!dataList || !this.BMapGL) return;
      const BMapGL = this.BMapGL;
      const markerIcon = new BMapGL.Icon(this.icon, new BMapGL.Size(25, 36));
      markerIcon.setImageSize(new BMapGL.Size(25, 36));
      const coordMap = new Map();
      dataList.forEach((ele) => {
        if (ele.centerPoint == null) return;
        const point = ele.centerPoint.split(",");
        //处理偏移量
        const key = `${point[0]},${point[1]}`;
        const count = coordMap.get(key) || 0;
        coordMap.set(key, count + 1);

        // 计算偏移后的点坐标
        let location = offsetLocation(count, point[0], point[1]);
        const point1 = new this.BMapGL.Point(location[0], location[1]);
        const data = { areaName: ele.areaName, totalPeople: ele.totalPeople };
        const icon = this.createCircleIcon(data);
        const marker = new BMapGL.Marker(point1, {
          icon,
          data, // 将数据附加到marker对象上
        });
        this.showInfoWindow3(marker, point1, data);
        this.map.addOverlay(marker);
        this.markers.push(marker);
      });
    },
    // 自定义显示信息窗口（聚合信息）
    showInfoWindow(marker, point, data) {
      const infoWindow = new this.BMapGL.InfoWindow(
        `<div style="padding:10px;min-width:180px;">
        <div style="margin:0 0 8px 0;color:#333;text-align:center;">${
          data.areaName || "未知地区"
        }</div>
        <div style="text-align:center;font-size:18px;margin:5px 0;font-weight:bold;">
          ${data.totalPeople}人
        </div>
      </div>`,
        {
          width: 100,
          offset: new this.BMapGL.Size(0, -25),
        }
      );

      marker.openInfoWindow(infoWindow);
    },
    // 自定义显示信息窗口（城镇以下非聚合）
    showInfoWindow3(marker, point, data) {
      console.log("进入showInfowindow3");
      const infoWindow = new this.BMapGL.InfoWindow(
        `<div style="padding:10px;min-width:180px;">
        <div style="margin:0 0 8px 0;color:#333;text-align:center;">111
        }</div>
        <div style="text-align:center;font-size:18px;margin:5px 0;font-weight:bold;">
          1人
        </div>
      </div>`,
        {
          width: 100,
          offset: new this.BMapGL.Size(100, -25),
        }
      );

      marker.openInfoWindow(infoWindow);
    },
  },
};
</script>

<style lang="less" scoped>
.MapBox {
  width: 100%;
  height: 900px;
  /* background-color: red; */
}

#allmap {
  width: 100%;
  height: 100%;
}
</style>
